window.addEventListener('DOMContentLoaded', () => {
    const elements = document.querySelectorAll('.slideElement');
    const observer = new IntersectionObserver(slideInElements);
    elements.forEach(element => observer.observe(element));
})

function slideInElements(entries) {
    entries.forEach(entry => {
        const { target } = entry;
        if (entry.isIntersecting) {
            target.classList.add('slide-in');
        }
    });
}